import axios from 'axios';
import { emitApiError, extractErrorMessage } from '../utils/apiErrors';
import { getAccessToken } from './tokenStore';

// Shared axios instance — all API calls go through this
// Auth interceptor stays in useAuth.ts since it needs React state (setUser)
const api = axios.create({
  withCredentials: true,
});

// Sync auth header from the in-memory token store (fnd-lly.3 — never
// localStorage; see tokenStore.ts for why)
api.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Global error interceptor — emits toast-friendly messages
// Skips 401s (handled by useAuth token refresh logic)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    // Skip 401 — useAuth handles token refresh
    if (status !== 401) {
      const message = extractErrorMessage(error);
      emitApiError(message);
    }

    return Promise.reject(error);
  }
);

export default api;
